import { render, staticRenderFns } from "./inviteOther.vue?vue&type=template&id=2e6ca1dc&scoped=true"
import script from "./inviteOther.vue?vue&type=script&lang=js"
export * from "./inviteOther.vue?vue&type=script&lang=js"
import style0 from "./inviteOther.vue?vue&type=style&index=0&id=2e6ca1dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6ca1dc",
  null
  
)

export default component.exports